<template>
  <div style="height:100%; display:flex;">
    <div style="background:#f3f3f3; padding:10px; height:100%; flex:1">
      <div style="border-left: 20px solid red; padding-left: 20px;">
        <div style="font-family: 'Raleway';">{{ form.NoKontrak }}</div>
        <div
          style="font-family: 'Raleway'; 
          font-weight: bold;"
        >
          {{ form.NamaPaket }}
        </div>
        <div>{{ form.NamaKontraktor }}</div>
        <br />
        <div>Rp. {{ form.NilaiKontrak | format }}</div>
        <div>
          {{ form.TglMulai | format }} -
          {{ form.TglSelesai | format }}
        </div>
      </div>
      <br />
      <Grid
        :datagrid.sync="kontrakTermin"
        dbref="DOC.SelKontrakTermin"
        :dbparams="kontrakTerminParams"
        :columns="[
          { name: 'Termin', value: 'TerminDesc', width: '100px' },
          { name: 'Tenggat Waktu', value: 'TglSelesai' },
          {
            name: 'Nilai',
            value: 'NilaiTermin',
            width: '100px',
            class: 'right',
          },
        ]"
        :disabled="true"
        :selectedRow="selectedRow"
        @row-click="OpenTermin"
      >
        <template v-slot:row-TerminDesc="{ row }">
          {{ row.TerminDesc }}
          <v-icon
            v-if="row.ActionTermin && row.ActionTermin !== 'Upload Dokumen'"
          >
            mdi-check-circle
          </v-icon>
        </template>
      </Grid>
    </div>
    <div style="flex:1.5; background: #eee; padding:10px;">
      <div
        style="border-left: 20px solid red; padding-left: 20px; margin-bottom: 20px;"
      >
        <div class="termin" style="font-family: 'Raleway'; font-weight: bold;">
          {{ formTermin.TerminDesc }}
        </div>
        <div style="font-size:small;">
          Rp. <span class="nilai">{{ formTermin.NilaiTermin | format }}</span>
        </div>
        <div style="font-size:small;">
          Akhir Termin:
          <span class="akhir">{{ formTermin.TglSelesai | format }}</span>
        </div>
      </div>
      <div
        style="background: rgba(100,100,100,0.1); border-radius: 10px; padding-bottom:10px; margin-bottom:5px;"
      >
        <div style="padding: 10px;">
          Dokumen yang harus di upload untuk verifikasi
        </div>
        <div
          style="border-radius: 10px; background:white; overflow:auto; height: calc(100vh - 250px);"
        >
          <div
            style="display: flex; padding:10px; border-bottom:1px solid #ddd"
            v-for="row in terminDocs"
            :key="row.DocName"
          >
            <div style="flex: 5;">
              <div
                style="font-family: 'Raleway'; font-size:large; font-weight:bold; padding-left:12px;"
              >
                {{ row.DocName }}
              </div>
              <v-btn
                text
                small
                color="primary"
                v-if="row.TemplateUrl == 'manual'"
                disabled
              >
                Verifikasi Manual
              </v-btn>
              <v-btn
                text
                small
                color="primary"
                v-else-if="row.TemplateUrl.substr(0, 4) == 'http'"
              >
                Download dari EPEN
              </v-btn>
              <v-btn
                text
                small
                color="primary"
                @click="DownloadTemplate(row)"
                v-else-if="row.TemplateUrl != 'manual'"
              >
                Download Template
              </v-btn>
              <v-icon v-if="row.DocUrl">
                mdi-circle-medium
              </v-icon>
              <v-btn
                text
                small
                color="primary"
                v-if="row.DocUrl && !row.ErrorList"
              >
                Download Dokumen
              </v-btn>
              <div
                style="margin-left: 14px; font-size: 14px; color: red;"
                v-if="row.ErrorList"
              >
                <div v-for="err in row.ErrorList" :key="err.message">
                  {{ err.message }}
                </div>
              </div>
            </div>
            <div
              style="display: flex; flex:1;
                justify-content: center;
                align-items: center;"
            >
              <Uploader @change="FileUploaded(row, $event)">
                <template v-slot="{ opener }">
                  <v-btn
                    fab
                    small
                    :color="
                      row.IsUploaded
                        ? row.ErrorList && row.ErrorList.length
                          ? 'warning'
                          : 'success'
                        : '#f3f3f3'
                    "
                    @click="opener"
                  >
                    <v-icon>
                      {{
                        row.IsUploaded
                          ? row.ErrorList && row.ErrorList.length
                            ? 'mdi-alert-circle'
                            : 'mdi-check'
                          : 'mdi-upload'
                      }}
                    </v-icon>
                  </v-btn>
                </template>
              </Uploader>
            </div>
          </div>
        </div>
      </div>
      <v-btn color="primary" @click="AjukanPengesahan">
        AJUKAN PENGESAHAN
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    form: {},
    termin: null,
    formTermin: {},
    kontrakTermin: [],
    terminDocs: [],
    selectedRow: -1,
  }),
  props: {
    kontrakId: [String, Number],
  },
  mounted() {
    this.Populate()
  },
  computed: {
    kontrakTerminParams() {
      return {
        KontrakID: this.kontrakId,
      }
    },
  },
  watch: {
    kontrakTermin(val) {
      if (val.length) {
        for (let i = 0; i < val.length; i++) {
          if (val[i].ActionTermin == 'Upload Dokumen') {
            this.OpenTermin(val[i])
            this.selectedRow = i
            break
          }
        }
      }
    },
  },
  methods: {
    async Populate() {
      let res = await this.$api.call('DOC.SelKontrak', {
        KontrakID: this.kontrakId,
      })
      if (res.data && res.data[0]) {
        this.form = res.data[0]
      }
    },
    async OpenTermin(data) {
      this.formTermin = data
      this.termin = data.Termin
      let trm = await this.$api.call('DOC.SelTerminDoc', {
        KontrakID: this.kontrakId,
        Termin: data.Termin,
      })
      this.terminDocs = trm.data.map(row => {
        if (row.ErrorList) row.ErrorList = JSON.parse(row.ErrorList)
        return row
      })
    },
    async FileUploaded(row, data) {
      let res = await this.$api.post('/api/doc/verify', {
        ...row,
        IsUploaded: true,
        DocUrl: data.data,
        Termin: this.termin,
      })
      row.IsUploaded = true
      if (!res.success) {
        row.ErrorList = res.data
      } else {
        row.DocUrl = data.data
        row.ErrorList = null
      }
      this.$api.call('DOC.SavTerminDoc', {
        ...row,
        IsUploaded: true,
        DocUrl: data.data,
        Termin: this.termin,
        ErrorList: row.ErrorList ? JSON.stringify(row.ErrorList) : null,
      })
    },
    async AjukanPengesahan() {
      let hasError = this.terminDocs.find(row => {
        if (row.ErrorList && row.ErrorList.length > 0) return true
        else if (!row.IsUploaded) return true
        else return false
      })
      let alasan = ''
      if (hasError) {
        alasan = prompt(
          'Masih terdapat dokumen yang SALAH atau BELUM DIUPLOAD, harap berikan alasan pengajuan:'
        )
        if (!alasan) return
      }
      if (alasan || confirm('Anda yakin mengajukan pengesahan?')) {
        await this.$api.call('DOC_SavAjukanPengesahan', {
          KontrakID: this.kontrakId,
          Alasan: alasan,
          Termin: this.termin,
        })
        this.$emit('close', true)
      }
    },
    async DownloadTemplate(row) {
      this.$api.download(
        `/api/doc/template/${row.TemplateUrl}?_KontrakID=${this.kontrakId}&_Termin=${this.termin}`
      )
    },
  },
}
</script>
